import type { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import type { Highlight } from "@/types/evidences";
import { toSpreadsheetTarget } from "@/modules/snapshots/grid/sidebar/sourceDocument";
import type { Evidence } from "@/types/evidences";
import type { EvidenceWithContext, FamilySource } from "./types";

/** Flattens an outcome's per-prompt evidence rows into citation-ready evidences. */
export const outcomeEvidences = (
  outcome: Pick<BusinessReportOutcomeDetails, "evidences" | "fs_entry">,
): EvidenceWithContext[] =>
  outcome.evidences.flatMap(evidence =>
    evidence.result.map(row => ({
      highlights: row.highlights ? (JSON.parse(row.highlights) as Highlight[]) : [],
      citationId: row.citation_id,
      documentId: row.document_id,
      fseId: row.fse_id,
      business_report_prompt_id: evidence.business_report_prompt_id,
      id: `evidence-${row.citation_id}`,
      answerOffsetEnd: 0,
      answerOffsetStart: 0,
      spreadsheetTarget: toSpreadsheetTarget(row.spreadsheet_target),
      sourceDocumentContentType: outcome.fs_entry?.content_type ?? null,
    })),
  );

/**
 * The evidence a page's citation markers resolve against. A one-document family copies that
 * document's cells, citation markers included, and has no evidence of its own, so it cites the
 * document's evidence; a consolidated family cites through its snapshot citations instead.
 */
export const citationEvidencesFor = (ownEvidences: Evidence[], familySources: FamilySource[]): Evidence[] =>
  familySources.length === 1 ? familySources[0].evidences : ownEvidences;
